import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useTheme } from "../contexts/ThemeContext";

export default function ThemeConfig({ children }) {
  const { theme: appTheme } = useTheme();
  
  const themeOptions = {
    palette: {
      mode: appTheme === 'dark' ? 'dark' : 'light',
      primary: {
        main: "#2a9988",
      },
      secondary: {
        main: appTheme === 'dark' ? "rgba(22, 52, 60, 1)" : "rgba(240, 240, 240, 1)",
      },
      text: {
        primary: appTheme === 'dark' ? "#90a7ad" : "#333333",
      },
      background: {
        default: appTheme === 'dark' ? "rgba(9, 35, 41, 1)" : "#f5f5f5",
        paper: appTheme === 'dark' ? "#0f2e36" : "#ffffff",
      },
    },
    typography: {
      fontFamily: '"Parkinsans", sans-serif',
    },
    components: {
      // Override Paper component to remove shadows and overlays
      MuiPaper: {
        styleOverrides: {
          root: {
            boxShadow: 'none',
            backgroundImage: 'none',
          },
        },
      },
      // Also override Card component (which uses Paper)
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: 'none',
            backgroundImage: 'none',
          },
        },
      },
    },
  };
  const theme = createTheme(themeOptions);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
